import { create } from 'zustand';

// Drives the mobile-only TopBar "Preview" button and the global full-screen widget dialog.
interface MobilePreviewStore {
  open: boolean;
  retainedScenarioId: string | null;
  openPreview: () => void;
  closePreview: () => void;
  handoffToSupport: (scenarioId: string) => void;
}

export const useMobilePreviewStore = create<MobilePreviewStore>((set) => ({
  open: false,
  retainedScenarioId: null,
  openPreview: () => set({ open: true, retainedScenarioId: null }),
  closePreview: () => set({ open: false, retainedScenarioId: null }),
  handoffToSupport: (scenarioId) => set({ open: false, retainedScenarioId: scenarioId }),
}));
